<div class="lds-ring" [ngClass]="color" >
  <ng-container *ngFor="let item of [1, 2, 3, 4]">
    <div></div>
  </ng-container>
</div>
